/* cjl-ugc-videos — módulo UGC (sección cjl-ugc-videos).
   · Lazy: el src del video se asigna al acercarse la sección (no se bajan 4 videos de entrada).
   · Autoplay muted loop playsinline cuando la card está ≥50 % en pantalla; pausa al salir.
   · Watch / tap en el video = sonido on/off para TODA la visita (5 oct): activo → el siguiente
     video también suena; Mute → mudos todos. Solo suena uno a la vez. El badge pasa a "Mute".
   · prefers-reduced-motion: sin autoplay — poster; Watch reproduce con sonido.
   · Móvil: los segmentos siguen al carrusel (swipe nativo).
   Sin JS: posters estáticos y cards shoppables. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var HOVER = window.matchMedia('(hover: hover) and (pointer: fine)');

  function init(root) {
    if (root.dataset.ugcReady) return;
    root.dataset.ugcReady = '1';

    var WATCH = root.dataset.watch || 'Watch';
    var MUTE = root.dataset.mute || 'Mute';
    var cards = [].slice.call(root.querySelectorAll('[data-ugc-card]'));
    var items = cards.map(function (card) {
      return {
        card: card,
        video: card.querySelector('.cjl-ugc__video'),
        btn: card.querySelector('[data-ugc-watch]'),
        visible: false
      };
    }).filter(function (it) { return it.video; });

    function load(it) {
      if (it.video.src || !it.video.dataset.src) return;
      it.video.src = it.video.dataset.src;
      it.video.preload = 'metadata';
    }

    function setSound(it, on) {
      it.video.muted = !on;
      if (!it.btn) return;
      var label = it.btn.querySelector('[data-ugc-label]');
      if (label) label.textContent = on ? MUTE : WATCH;
      else it.btn.textContent = on ? MUTE : WATCH;
      it.btn.classList.toggle('is-on', on);
      it.btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      it.btn.setAttribute('aria-label', (on ? 'Mute video' : 'Unmute video') + it.btn.getAttribute('aria-label').replace(/^[^—]*/, ' '));
    }

    /* Preferencia de sonido de la visita (5 oct): si el visitante lo activa, sigue activo al pasar
       al siguiente video (swipe, flechas o al acabar); si lo silencia, se silencian todos. Solo
       suena uno a la vez: el que se está viendo (active). */
    var soundOn = false;
    function applySound(active) {
      items.forEach(function (o) {
        var want = soundOn && o === active;
        if (!o.video.muted !== want) setSound(o, want);
      });
    }
    function sounding() {
      return items.filter(function (o) { return o.visible && !o.video.muted; })[0] || null;
    }
    /* iOS Safari solo deja quitar el mute a un <video> si ocurre dentro de un toque sobre ÉL;
       si luego lo hace el script (swipe, avance automático) lo bloquea y el siguiente arranca
       mudo. Desbloqueo: en el MISMO toque que activa el sonido, cada video hace mute → unmute
       → mute (síncrono: no suena nada ni se descarga nada). Desde ahí el script puede darles voz. */
    var unlocked = false;
    function unlockAll(except) {
      if (unlocked) return;
      unlocked = true;
      items.forEach(function (o) {
        if (o === except || !o.video.muted) return;
        o.video.muted = false;
        o.video.muted = true;
      });
    }

    function play(it) {
      load(it);
      var p = it.video.play();
      if (p && p.catch) p.catch(function () {
        /* iOS puede negar el play con sonido si no viene de un toque: sigue mudo. */
        if (it.video.muted) return;
        setSound(it, false);
        it.video.play().catch(function () {});
      });
    }

    /* Móvil + setting: solo reproduce la card centrada; al acabar, centra la siguiente. */
    var track = root.querySelector('[data-ugc-track]');
    var MOBILE = window.matchMedia('(max-width: 989px)');
    function isAuto() {
      return root.hasAttribute('data-ugc-auto') && track && MOBILE.matches && !REDUCED.matches;
    }
    function centered() {
      var tr = track.getBoundingClientRect(), mid = tr.left + tr.width / 2, best = null, dist = Infinity;
      items.forEach(function (it) {
        var r = it.card.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < dist) { dist = d; best = it; }
      });
      return best;
    }
    function syncAuto() {
      var c = centered();
      var active = c && c.visible ? c : null;
      applySound(active); /* antes del play: el centrado arranca ya con la preferencia */
      items.forEach(function (it) {
        if (it === active) play(it);
        else if (!it.video.paused) it.video.pause();
      });
    }
    function centerOn(it) {
      var tr = track.getBoundingClientRect(), r = it.card.getBoundingClientRect();
      track.scrollBy({ left: (r.left + r.width / 2) - (tr.left + tr.width / 2), behavior: 'smooth' });
    }
    function setLoop() {
      var auto = isAuto();
      items.forEach(function (it) { it.video.loop = !auto; });
    }
    setLoop();
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', setLoop);
    var startIt = items[(parseInt(root.dataset.ugcStart, 10) || 1) - 1];
    if (startIt && startIt !== items[0] && isAuto()) {
      var tr0 = track.getBoundingClientRect(), r0 = startIt.card.getBoundingClientRect();
      track.scrollTo({ left: track.scrollLeft + (r0.left + r0.width / 2) - (tr0.left + tr0.width / 2), behavior: 'instant' });
    }

    var lit = null;
    function markCenter() {
      var c = isAuto() ? centered() : null;
      if (c === lit) return;
      if (lit) lit.card.classList.remove('is-center');
      if (c) c.card.classList.add('is-center');
      lit = c;
    }
    markCenter();
    if (MOBILE.addEventListener) MOBILE.addEventListener('change', markCenter);
    if (track) {
      var settle = null, marking = false;
      track.addEventListener('scroll', function () {
        if (!isAuto()) return;
        if (!marking) {
          marking = true;
          requestAnimationFrame(function () { marking = false; markCenter(); });
        }
        clearTimeout(settle);
        settle = setTimeout(syncAuto, 140);
      }, { passive: true });
    }
    items.forEach(function (it, i) {
      it.video.addEventListener('ended', function () {
        if (!isAuto()) return;
        var nx = items[(i + 1) % items.length];
        /* El sonido lo pasa syncAuto al asentarse el centrado (preferencia soundOn). */
        if (nx.video.readyState) nx.video.currentTime = 0;
        centerOn(nx);
      });
    });

    function toggle(it) {
      var on = it.video.muted || it.video.paused;
      if (on) {
        /* Sonido on para la visita; suena solo este (y se pausan los demás si no hay autoplay). */
        soundOn = true;
        unlockAll(it);
        applySound(it);
        if (REDUCED.matches) items.forEach(function (o) { if (o !== it) o.video.pause(); });
        play(it);
      } else {
        /* Mute = mute para todos los que vengan. */
        soundOn = false;
        applySound(null);
        if (REDUCED.matches || !it.visible) it.video.pause();
      }
    }

    items.forEach(function (it) {
      if (it.btn) {
        it.btn.hidden = false;
        it.btn.addEventListener('click', function (e) { e.preventDefault(); toggle(it); });
      }
      /* Sin badge (setting "Botón de sonido" apagado) el tap no hace nada: videos mudos. */
      if (it.btn) it.video.addEventListener('click', function () { toggle(it); });
      /* Desktop (varios videos a la vez): con sonido activo, el sonido sigue al cursor — suena
         el video que el visitante está mirando, no el primero que lo tuvo. */
      it.card.addEventListener('mouseenter', function () {
        /* Solo con ratón real: en táctil el tap emula mouseenter y luego el click haría toggle. */
        if (!HOVER.matches) return;
        if (!soundOn || isAuto() || REDUCED.matches || !it.visible || !it.video.muted) return;
        applySound(it);
        play(it);
      });
      /* Si el video falla (URL rota, formato), vuelve el poster y se retira el badge. */
      it.video.addEventListener('error', function () {
        it.video.style.visibility = 'hidden';
        if (it.btn) it.btn.hidden = true;
      });
    });

    if ('IntersectionObserver' in window) {
      /* Precarga de metadatos ~1 viewport antes de llegar. */
      var near = new IntersectionObserver(function (entries, io) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        items.forEach(load);
      }, { rootMargin: '100% 0px' });
      near.observe(root);

      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var it = items.filter(function (x) { return x.card === e.target; })[0];
          if (!it) return;
          it.visible = e.isIntersecting;
          if (isAuto()) {
            syncAuto();
          } else if (it.visible && !REDUCED.matches) {
            /* Con sonido activo y nadie sonando en pantalla, el que entra se lleva el sonido. */
            if (soundOn && !sounding()) applySound(it);
            play(it);
          } else if (!it.visible) {
            it.video.pause();
            if (!it.video.muted) {
              setSound(it, false);
              /* El que sonaba salió (flechas/scroll): el sonido pasa al primero visible. */
              var nx = soundOn && !REDUCED.matches ? items.filter(function (o) { return o.visible; })[0] : null;
              if (nx) { applySound(nx); play(nx); }
            }
          }
        });
      }, { threshold: 0.5 });
      items.forEach(function (it) { vis.observe(it.card); });
    }

    /* Segmentos del carrusel móvil. */

    /* Flechas desktop (1 oct): una card por clic; se ocultan si caben todas, se apagan en los extremos. */
    var nav = root.querySelector('[data-ugc-nav]');
    if (track && nav) {
      var prev = nav.querySelector('[data-ugc-prev]'), next = nav.querySelector('[data-ugc-next]');
      var stepOf = function () { return cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth; };
      var syncNav = function () {
        var max = track.scrollWidth - track.clientWidth;
        nav.hidden = max <= 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      };
      prev.addEventListener('click', function () { track.scrollBy({ left: -stepOf(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: stepOf(), behavior: 'smooth' }); });
      track.addEventListener('scroll', syncNav, { passive: true });
      window.addEventListener('resize', syncNav);
      syncNav();
    }
    var dots = [].slice.call(root.querySelectorAll('[data-ugc-dots] i'));
    if (track && dots.length) {
      var ticking = false, cur = 0;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var first = cards[0], second = cards[1];
          if (!first) return;
          var step = second ? second.offsetLeft - first.offsetLeft : first.offsetWidth;
          if (!step) return;
          var max = track.scrollWidth - track.clientWidth;
          var i = track.scrollLeft >= max - 2 ? dots.length - 1 : Math.round(track.scrollLeft / step);
          i = Math.max(0, Math.min(dots.length - 1, i));
          if (i === cur) return;
          dots[cur].classList.remove('is-active');
          dots[i].classList.add('is-active');
          cur = i;
        });
      }, { passive: true });
    }
  }

  function initAll() {
    [].forEach.call(document.querySelectorAll('[data-cjl-ugc]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);

  /* Re-enganche si la sección se re-renderiza fuera del editor (hot reload de theme dev). */
  if ('MutationObserver' in window) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; initAll(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
